import React, { useState, useEffect, useRef } from 'react';

const MultiSelect = ({ options, value = [], onChange, placeholder = "Select..." }) => {
    const [isOpen, setIsOpen] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [wrapperRef]);

    const toggleOption = (option) => {
        const newValue = value.includes(option)
            ? value.filter(v => v !== option)
            : [...value, option];
        onChange(newValue);
    };

    return (
        <div className="relative" ref={wrapperRef}>
            <div
                className="w-full min-h-[38px] px-3 py-2 border border-gray-300 rounded-md bg-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-indigo-500 flex flex-wrap gap-1 items-center"
                onClick={() => setIsOpen(!isOpen)}
            >
                {value.length > 0 ? (
                    value.map(val => (
                        <span key={val} className="bg-indigo-100 text-indigo-800 text-xs px-2 py-0.5 rounded-full flex items-center">
                            {val}
                            <button
                                type="button"
                                className="ml-1 hover:text-indigo-900"
                                onClick={(e) => { e.stopPropagation(); toggleOption(val); }}
                            >
                                ×
                            </button>
                        </span>
                    ))
                ) : (
                    <span className="text-gray-400 text-sm">{placeholder}</span>
                )}
                <div className="ml-auto pointer-events-none">
                    <svg className="h-4 w-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                </div>
            </div>

            {isOpen && (
                <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
                    {options.map(option => (
                        <div
                            key={option}
                            className={`px-3 py-2 cursor-pointer text-sm hover:bg-gray-100 flex items-center ${value.includes(option) ? 'bg-indigo-50 text-indigo-700' : 'text-gray-700'}`}
                            onClick={() => toggleOption(option)}
                        >
                            <input
                                type="checkbox"
                                checked={value.includes(option)}
                                readOnly
                                className="mr-2 h-4 w-4 text-indigo-600 rounded border-gray-300 focus:ring-indigo-500"
                            />
                            {option}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MultiSelect;
